import { render } from "./EmployeePage.vue?vue&type=template&id=0288d06b"
import script from "./EmployeePage.vue?vue&type=script&lang=js"
export * from "./EmployeePage.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__